// extracted by mini-css-extract-plugin
export var button = "_jb-0";
export var donut = "_jb-1";
export var donutFill = "_jb-3";
export var donutTrack = "_jb-2";